import { VoiceDemoProvider } from '../../providers/VoiceDemoContext';
import { useVoices } from '../../providers/VoicesProvider';

import { VoiceDemo } from './VoiceDemo';
import { SkeletonLoader } from './SkeletonLoader';

export const VoiceDemoRoot = () => {
  const { loading } = useVoices();

  if (loading) {
    return <SkeletonLoader />;
  }

  return (
    <VoiceDemoProvider>
      <div className="studio-vo-demo-styling">
        <div className="flex justify-center @container">
          <VoiceDemo />
        </div>
      </div>
    </VoiceDemoProvider>
  );
};
